// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ERROR_COULD_NOT_PERFORM_ACTION = "Ups chyba, nepoda\u0159ilo se :(";
export const PHOTOBLOG_ARTICLE_CONTENT_IS_CONVERTING = "Konvertuju form\u00e1t \u010dl\u00e1nku ...";
